// Todo error que la web captura queda registrado en el log del servidor
// (POST /client-logs → línea "ClientError" en Render), además de mostrarse en
// pantalla. Sobre todo los que nunca pasan por nuestra API, como la subida
// directa a Cloudinary. Solo datos técnicos: nada de correos, nombres ni tokens.

const API_URL = process.env.NEXT_PUBLIC_API_URL ?? 'http://localhost:3001/api'

export interface ErrorDetails {
  httpStatus?: number
  // Respuesta del servicio externo (ej. el mensaje de error de Cloudinary).
  detail?: string
}

// Error con el dato técnico para el log, sin perder el mensaje legible que se
// le muestra a la persona.
export class ReportableError extends Error {
  constructor(message: string, readonly details: ErrorDetails = {}) {
    super(message)
  }
}

export function reportError(context: string, err: unknown, extra: ErrorDetails = {}): void {
  const message = err instanceof Error ? err.message : String(err)
  const details = { ...(err instanceof ReportableError ? err.details : {}), ...extra }
  console.error(`[${context}]`, message, details)
  // keepalive: el reporte sale aunque la persona cierre o cambie de página.
  // Si el propio reporte falla, solo queda en la consola.
  fetch(`${API_URL}/client-logs`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    keepalive: true,
    body: JSON.stringify({
      source: 'web',
      platform: 'browser',
      context,
      message: message.slice(0, 1000),
      detail: details.detail?.slice(0, 2000),
      httpStatus: details.httpStatus,
    }),
  }).catch((e: unknown) => console.error('[client-log] no se pudo reportar', e))
}
